<template>
    <div class="col-3" style="cursor: pointer;">
    <div class="ship-tile card mb-4" @click="selectShip">
        <div>
        <ShipView :ship="ship" :view="'profile'" :scale="ship.particulars.Loa/350"/>
        <h5 class="card-title">{{ship.typeDescr}}</h5>
        <h6 class="card-subtitle mb-2 text-muted">{{ship.typeDescr2}}</h6>
        </div>
        <button @click.stop="customiseShip">customise</button>
    </div>
    </div>
</template>

<script>
import ShipView from "./ShipView.vue";

export default {
  name: "ShipTile",
  components: {
      ShipView
  },
  props: {
      ship: Object
  },
  methods: {
      selectShip() {
          this.$emit("onSelectShip", this.ship, false);
      },
      customiseShip() {
          this.$emit("onSelectShip", this.ship, true);
      }
  }
}

</script>

<style scoped>
.ship-tile {
    border-color: #3b8ede;
}
.ship-tile>div:hover {
    background-color: #3b8ede;
}
</style>